import { EntityDescriptor, EntityEditorPage, EntityEditorPageProps } from "@crispico/foundation-react";
import { TotalQuantityFieldDescriptor } from "../TotalQuantityFieldDescriptor";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import { TabRouterPane } from "@crispico/foundation-react/components/TabbedPage/TabbedPage";

export class InvoiceLineEntityDescriptor extends EntityDescriptor {
    constructor() {
        super({
            name: "InvoiceLine",
            icon: "file text"
        });
    }

    protected customize() {
        this.addFieldDescriptor({ name: "price", type: FieldType.number });
        this.addFieldDescriptor({ name: "total", type: FieldType.number });
        this.addFieldDescriptor({ name: "debords", type: FieldType.number });
        this.addFieldDescriptor({ name: "quantity", type: FieldType.number });
        this.addFieldDescriptor({ name: "totalQuantity" }, new TotalQuantityFieldDescriptor());
        this.isInDefaultColumnConfig(true, "unitType", "debords", "quantity", "totalQuantity", "price", "total", "designation");

        this.infoEditor.wrappedComponentClass = class extends EntityEditorPage<EntityEditorPageProps> {
            protected getExtraTabPanes(): (TabRouterPane | null)[] {
                return [
                    ...super.getExtraTabPanes(),
                    this.createOneToManyTabPane("InvoiceData", "invoiceLine")
                ];
            }
        }
    }
}
